import { render, staticRenderFns } from "./MessagesCockpitCard.vue?vue&type=template&id=4fe15a9c&scoped=true&"
import script from "./MessagesCockpitCard.vue?vue&type=script&lang=ts&"
export * from "./MessagesCockpitCard.vue?vue&type=script&lang=ts&"
import style0 from "./MessagesCockpitCard.vue?vue&type=style&index=0&id=4fe15a9c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fe15a9c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
